angular.module('assets')
    .component('documentNumberHeader', {
        bindings: {
            tag: '<',
            number: '<'
        },
        template: `
            <div class="input-group input-group-sm">
                <span class="bold" style="font-size: large">
                    <document-tag-ico tag="$ctrl.tag"></document-tag-ico>
                    <span>
                        {{ 'asset-doc.no' | translate }} <span style="color: #e87171;">{{$ctrl.number}}</span>
                        <span style="font-size: x-small;font-weight: normal">({{ 'asset-doc.tag.'.concat($ctrl.tag) | translate }})</span>
                    </span>
                </span>
            </div>
        `,
    })
